import { Subscriptions, SubscriptionDetail } from '../../models/subscriptions.model';
import { CartService } from '../../services/cart.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InitService } from 'src/app/shared/services/init.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';


@Component({
  selector: 'hs-subscription-modal',
  templateUrl: './subscription-modal.component.html',
  styleUrls: ['./subscription-modal.component.scss']
})
export class SubscriptionModalComponent implements OnInit, OnDestroy {

  closeBtnName: string;
  subscriptions: Subscriptions;

  /**
   * Annually subscriptions are shown by default.
   */
  monthly = false;
  /**
   * Pro subscriptions are shown by default.
   */
  proSelected = true;

  subscription: Subscription = null;

  constructor(
    public bsModalRef: BsModalRef,
    private cart: CartService,
    private init: InitService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.subscription = this.init.data.subscribe(response => {
      this.subscriptions = response.subscriptions;
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  addSubscriptionToCart() {
    this.bsModalRef.hide();
    this.cart.addSubscription(this.getCurrentSubscription(), this.monthly).subscribe(() => {
      this.router.navigate(['/checkout']);
    });
  }

  getCurrentPrice(): number {
    if (!this.subscriptions) {
      return null;
    }

    if (this.monthly) {
      return this.getCurrentSubscription().price;
    }
    return this.getCurrentSubscription().monthlyPrice;
  }

  private getCurrentSubscription(): SubscriptionDetail {
    if (!this.subscriptions) {
      return null;
    }
    if (this.proSelected) {
      if (this.monthly) {
        return this.subscriptions.pro.monthly;
      } else {
        return this.subscriptions.pro.annually;
      }
    } else {
      if (this.monthly) {
        return this.subscriptions.business.monthly;
      } else {
        return this.subscriptions.business.annually;
      }
    }
  }

  changeSubscription() {
    this.monthly = !this.monthly;
  }

}
